import "./pdfWorkerSetup";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RootApp from "./RootApp";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);
